module.exports = __webpack_public_path__ + "img/carrot.6e7ba80b.jpg";